<div class="form-field">
    <span class="form-field-label" *ngIf="label">
        {{ label }}<span class="required" *ngIf="required"> *</span>
    </span>
    <mat-select [disabled]="disabled" [(value)]="currentValue" [placeholder]="placeholder" [disabled]="" (selectionChange)="onValueChange($event.value)" [style]="selectStyle">
        <mat-option [value]="option.value" *ngFor="let option of options">
            {{ option.label }}
        </mat-option>
    </mat-select>
</div>